@if (userDetails) {
    <div class="w-full max-w-3xl">
        <!-- Form -->
        <form [formGroup]="form" #profileInNgForm="ngForm">
            <!-- Section -->
            <div class="prose prose-sm !max-w-100 col-span-4">
                <div class="font-semibold text-lg flex items-center">
                    <span class="mr-3 flex items-center">
                        <i class="fa-solid fa-address-card text-primary-500 fa-lg" [color]="'primary'"></i>
                    </span>
                    <span class="mt-[2px]">{{ 'label_general_information' | translate }}</span>
                </div>
            </div>
            <div class="grid grid-cols-4 gap-6 w-full mt-4">
                <div class="col-span-4 sm:col-span-2">
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>{{ 'label_name' | translate }}</mat-label>
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:user'" matPrefix></mat-icon>
                        <input id="name" [formControlName]="'nafn'" matInput />
                        <button mat-icon-button matSuffix type="button" (click)="copyLink(form.get('nafn').value)">
                            <mat-icon class="icon-size-5" svgIcon="mat_solid:content_copy"></mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="col-span-4 sm:col-span-2">
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>{{ 'label_phone_number' | translate }}</mat-label>
                        <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:phone_iphone'" matPrefix></mat-icon>
                        <input [formControlName]="'simanumer'" matInput />
                        <button mat-icon-button matSuffix type="button" (click)="copyLink(form.get('simanumer').value)">
                            <mat-icon class="icon-size-5" svgIcon="mat_solid:content_copy"></mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
            <!-- Divider -->
            <div class="mt-11 mb-1 border-t"></div>
            @if (lsrauthService.inRole(userDetails, userRoles.USER_SELECTOR)) {
                <div class="mt-1 text-md float-left" (click)="openUserSelectModal()">
                    <span class="mr-[5px]"><i class="fa-solid fa-user-lock text-primary"></i></span>
                    <span class="c-link">{{ 'label_pick_another_user' | translate }} </span>
                </div>
            }
        </form>
    </div>
}
